import { GroupTravelBindState } from "./types";
import { createInitialState as createFormInitialState } from "../Form/state";

const createInitialState = (persistedState: Partial<GroupTravelBindState> = {}): GroupTravelBindState => {
  return {
    streetNumber: "",
    unitNumber: "",
    floorNumber: "",
    streetName: "",
    suburb: "",
    state: "",
    australiaBusinessNo: "",
    postalCode: "",
    accepted: false,
    acceptedNotice: false,
    ...createFormInitialState(),
    ...persistedState,
  };
};

export default createInitialState;
